import { Flex, Button, Box, useBreakpointValue, VStack, useTheme } from '@telescope/cassini-ui';
import { useWidget } from '@telescope/cassini-hooks';
import { Heading, Text } from 'components';
import { useAuth } from 'features/auth';
import { SlotMachine } from './SlotMachine';
import { SlotMachineOpen } from 'types';
import { cubicBezier } from 'framer-motion';
import { useSlotMachine, useSpinToWin, SLOT_MACHINE_SIZE } from 'features';

const ANIMATION_OPTIONS = {
  TO_AUTH: {
    ease: cubicBezier(.87,.98,.82,1)
  },
  TO_PRIZE: {
    ease: cubicBezier(.87,.98,.82,1)
  },
}

export const LandingPage = () => {
  const { isAnimating, isMultiSpin, spinsRemaining, voteLimit, handleSpinToAuth, onAnimationComplete } = useSpinToWin();
  const { prizes, targets } = useSlotMachine();

  const { isAuthorizing, user } = useAuth();
  const { data } = useWidget({ select: (data: SlotMachineOpen) => data.snapshot.snapshot_views.landing });
  const { content, settings, styles } = data!;

  const { data: slotMachine } = useWidget({ select: (data: SlotMachineOpen) => data.snapshot.snapshot_views.slotMachine });
  const { content: slotMachineContent, styles: slotMachineStyles } = slotMachine!;

  const displayRemainingSpins = settings.displayRemainingSpins && isMultiSpin && user;
  const spinsRemainingLabel = content.spinsRemaining[spinsRemaining === 1? 'singular' : 'plural']
    ?.replace('{{COUNT}}', `${spinsRemaining}`)
    .replace('{{TOTAL}}', `${voteLimit}`)

  const theme = useTheme();
  const { defaultColorScheme: c } = theme.settings;
  const slotMachineSize = useBreakpointValue(SLOT_MACHINE_SIZE)!;


  return (
    <Flex direction="column" align="center" mb={2}>
      <Box textAlign="center" mb={5}>
        <Text allowMarkdown={true} mb={5}>
          {slotMachineContent.topDescription}
        </Text>
        <Heading size="2xl" mb={3} allowMarkdown={true}>{slotMachineContent.headline}</Heading>
        <Text allowMarkdown={true}>
          {slotMachineContent.description}
        </Text>
      </Box>

      <VStack spacing={2} mb={5}>
        <Button size={["md", "md", "xl"]} variant="pill" onClick={handleSpinToAuth} 
            isDisabled={isAnimating || isAuthorizing} className="SlotMachine__spin-button">
              { isMultiSpin && user ? content.spinButton.spinAgain : content.spinButton.default }
        </Button>
        { displayRemainingSpins && <Text fontSize="xs"> {spinsRemainingLabel} </Text> }
      </VStack>
      
      <Box py={7} position="relative">
        <Box position="absolute" w="100vw" h="100%" top={0} left="50%" transform="translateX(-50%)" maxW={settings.isContainerFullWidth? "100vw" : "app"} bg={styles.container.backgroundColor}>
          <Box position="absolute" w="full" h="100%" top={0} left="50%" transform="translateX(-50%)" sx={{ ...styles.container }} />
        </Box>

        <Flex direction="column" align="center" w="100%" >
          { isAuthorizing? 
            <Box opacity={0.3} filter="blur(1rem)" bg={`${c}.500`} {...slotMachineSize}/> :
            <SlotMachine 
              targets={targets}
              slots={prizes}
              options={{
                animation: user ? ANIMATION_OPTIONS.TO_PRIZE : ANIMATION_OPTIONS.TO_AUTH
              }}
              onComplete={onAnimationComplete}
              isAnimating={isAnimating}
              styles={slotMachineStyles.reels} /> }
        </Flex>
      </Box>

    </Flex>
  )
}